import type { ComponentProps } from 'react';
import React, { forwardRef } from 'react';
import { sanitizeURL } from '@/utils/domain/route';
import { Link } from '@skin-seoul/design-system';
import NextLink from 'next/link';
import { isEmpty } from 'es-toolkit/compat';
export type SafeLinkProps = {
  href: string;
} & ComponentProps<typeof Link>;

/**
 * NOTE: https://github.com/vercel/next.js/issues/65335#issuecomment-2583401824
 * To navigate to an internal or external route, use the `SafeLink` component.
 * There is an issue that navigating performance is too low, when we navigate to wordpress route with next/link without origin.
 * @param param0
 * @returns
 */
export const SafeLink = forwardRef<HTMLAnchorElement, SafeLinkProps>(({
  href,
  children,
  ...props
}, ref) => {
  const {
    url
  } = sanitizeURL(href);
  return <Link {...isEmpty(props) && {
    unstyled: true
  }} {...props} asChild ref={ref}>
      <NextLink href={url} prefetch={false}>
        {children}
      </NextLink>
    </Link>;
});